<template>
	<div
		class="list-tile"
		:class="{
			'is-mobile': isMobileWebApp,
		}"
	>
		<div class="content">
			<div
				class="list-tile__leading"
			>
				{{ item.order }}
			</div>
			<div class="list-tile__body">
				<div class="list-tile__title-wrapper">
					<h3 class="list-tile__title">
						{{ item.tag_name }}
					</h3>
				</div>
			</div>
			<div
				v-if="startTime"
				class="list-tile__trailing"
			>
				{{ startTime }}
			</div>
		</div>
		<div class="bottom">
			<div class="divider" />
		</div>
	</div>
</template>

<script>
import { getDateTime } from '@shared/utils/timeUtils';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
	name:  'TagTemplateTile',
	props: {
		item: {
			type:    Object,
			default: null,
		},
	},
	computed: {
		...mapGetters({
			isMobileWebApp: 'app/isMobileWebApp',
		}),
		startTime() {
			return this.item.start_time ? getDateTime(moment(this.item.start_time, 'HH:mm:ss').unix(), { withDate: false }) : null;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.list-tile {
	display: flex;
	position: relative;
	flex-direction: column;
	margin-top: -1px;

	body.-t-light & {
		color: var(--color-black);
	}

	.content {
		display: flex;
		height: 64px;
		margin: 8px 8px 0 8px;
	}

	&.is-mobile {
		.list-tile__trailing {
			margin-right: 8px;
		}
	}

}

.list-tile__leading {
	display: flex;
	height: 64px;
	min-width: 64px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 39px;
	font-weight: 700;
	color: var(--color-grey-800);
	letter-spacing: -0.1em;
}

.list-tile__body {
	flex-grow: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 0 8px 0 16px;
	gap: 8px;
}

.list-tile__title-wrapper {
	display: flex;
	align-items: center;
}

.list-tile__title {
	@include text-md-1;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box; // stylelint-disable-line value-no-vendor-prefix
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical; // stylelint-disable-line property-no-vendor-prefix
	white-space: normal;
}

.list-tile__trailing {
	@include text-sm-1;
	color: var(--color-grey-300);
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	white-space: nowrap;
}

.bottom {
	margin-left: 8px;
	margin-right: 8px;

	.divider {
		overflow: hidden;
		margin-top: 7px;
		height: 1px;
		background: var(--color-grey-900);
	}
}
</style>
